export const BOOTSTRAP_ACCOUNTS = 'BOOTSTRAP_ACCOUNTS'
export const ADD_ACCOUNT = 'ADD_ACCOUNT'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
// export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
// export const DELETE_MULTIPLE_ACCOUNTS = 'DELETE_MULTIPLE_ACCOUNTS'
export const SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS'
export const SET_TOTAL_ACCOUNTS = 'SET_TOTAL_ACCOUNTS'
// export const RESET_SELECTED_ACCOUNT = 'RESET_SELECTED_ACCOUNT'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_TOTAL_FUNDER_ACCOUNTS ='SET_TOTAL_FUNDER_ACCOUNTS'
export const FUNDER_ACCOUNTS ='FUNDER_ACCOUNTS'
export const SET_SELECTED_FUNDER_ACCOUNT = 'SET_SELECTED_FUNDER_ACCOUNT'
export const SET_SELECT_ALL_FUNDER_STATE = 'SET_SELECT_ALL_FUNDER_STATE'
export const VIEW_ACCOUNT ='VIEW_ACCOUNT'
export const SET_SELECTED_AUDIT_ACCOUNT = 'SET_SELECTED_AUDIT_ACCOUNT'
export const SET_SELECTED_ISLAMIC_FORM = 'SET_SELECTED_ISLAMIC_FORM'
